export enum TelaEnum{
    usuario = 1,
    produto = 2,
    cliente = 3,
    cupom = 4,
    rota = 5,
    intinerario = 6
}